import { useState } from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import dateFormat from 'dateformat'
import { contentfulImageTransformation } from '../../../lib/data-transformations'
import paths from '../../../paths/path'
import ViewAllCTA from '../../interactives/Buttons/ViewAllCTA'
import WorkshopListItem from '../../WorkshopComponents/WorkshopListItem'
import ContentCardListing from '../ContentCardListing'

export default function ContentGrid({
  sectionTitle,
  items,
  contentLimit = 0,
  showDivider = true,
  showViewAll = true,
  viewAllLink = paths.search({ types: [] }),
  columnWidth = 4,
  variant,
  limit = 12,
  type,
}) {
  const [gridLimit, setGridLimit] = useState(limit)

  const loadMore = () => {
    setGridLimit(gridLimit + 6)
  }

  const renderItems = (items, columnWidth) => {
    return items
      .slice(0, contentLimit ? contentLimit : items.length)
      .map(({ slug, thumbnail, topic, title, date, endDatetime }, key) => {
        return (
          <Grid item xs={12} md={columnWidth} key={key}>
            <ContentCardListing
              slug={slug}
              thumbnail={thumbnail}
              topic={topic}
              title={title}
              date={date}
              endDatetime={endDatetime}
              type={type}
            />
          </Grid>
        )
      })
  }

  const renderWorkshopItems = (items, columnWidth) => {
    return items
      .slice(0, `${contentLimit ? contentLimit : items.length}`)
      .filter(
        ({
          linkedFrom: {
            workshopVariationCollection: { items: variationItems },
          },
        }) => {
          const variation = variationItems[0]
          const workshop = variation?.linkedFrom?.workshopCollection?.items[0]
          return !!workshop
        }
      )
      .map(
        ({
          startDatetime,
          sessionId,
          linkedFrom: {
            workshopVariationCollection: { items: variationItems },
          },
        }) => {
          const variation = variationItems[0]
          const workshop = variation?.linkedFrom?.workshopCollection?.items[0]
          return (
            <Grid item xs={12} md={columnWidth} key={sessionId}>
              <WorkshopListItem
                useMemberBookPrice
                mediaImg={contentfulImageTransformation(
                  workshop?.spotlightImage
                )}
                title={variation?.title}
                topicTag={workshop?.type?.title}
                authorName={workshop?.authors?.items
                  ?.map((a) => `${a?.firstName} ${a?.lastName}`)
                  .join(' & ')}
                workshopDate={dateFormat(startDatetime, 'mediumDate')}
                clockHours={`${workshop.clockHours} Professional Learning Hours`}
                memberPrice={variation?.memberPrice?.toFixed(2)}
                nonMemberPrice={variation?.nonMemberPrice?.toFixed(2)}
                id={variation?.variationId}
                actionHref={paths.workshop({
                  slug: `${workshop.slug}/${
                    variation ? variation.variationId : ''
                  }`,
                })}
              />
            </Grid>
          )
        }
      )
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box display='flex' justifyContent='space-between'>
          <Box>
            <Typography variant='h4'>{sectionTitle}</Typography>
          </Box>

          {showViewAll && (
            <Box>
              <ViewAllCTA href={viewAllLink} label='View all' lg />
            </Box>
          )}
        </Box>
        {showDivider && (
          <Box mt={[1.5, 2.5]}>
            <Divider
              sx={{
                height: '1px',
                bgcolor: 'grey.light',
                width: '100%',
              }}
            />
          </Box>
        )}
      </Grid>
      {variant === 'workshop'
        ? renderWorkshopItems(items.slice(0, gridLimit), columnWidth)
        : renderItems(items.slice(0, gridLimit), columnWidth)}
      <Box my={10} textAlign='center'>
        {gridLimit < (contentLimit || items.length) && (
          <Button onClick={() => loadMore()} startIcon={<ArrowDownwardIcon />}>
            <Typography variant='h5'>View More</Typography>
          </Button>
        )}
      </Box>
    </Grid>
  )
}
